import { render } from "./DeviationCrewTypeInput.vue?vue&type=template&id=5a80c767"
import script from "./DeviationCrewTypeInput.vue?vue&type=script&lang=ts"
export * from "./DeviationCrewTypeInput.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
